import React, { useState } from "react";
import { MdLock } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/toys-bg.png";
import reset from "../assets/reset.png";
import { useForgetPassword } from "../../context/ForgetPasswordContext";

const ResetPassword = () => {
  const { resetPassword, resetToken} = useForgetPassword();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!password || !confirmPassword) {
      setError("Both fields are required.");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    if (!resetToken) {
      setError("Missing reset token. Please restart the process.");
      return;
    }
    
    setLoading(true);

    const response = await resetPassword(resetToken, password);

    setLoading(false);

    if (response.status === 200) {
      alert("✅ Password reset successful!");
      navigate("/login");
    } else {
      setError(response.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <section
      className="min-h-screen flex justify-center md:justify-end items-center bg-cover bg-center px-4"
      style={{ backgroundImage: `url("https://cdn.acsdev.in/Rentastic/toysb.png")` }}
    >
      <div className="w-full max-w-md sm:max-w-sm md:max-w-md lg:max-w-lg bg-white/90 backdrop-blur-sm rounded-2xl shadow-md p-6 sm:p-8 md:p-10 mx-4 md:mr-16 lg:mr-32">
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 rounded-full flex items-center justify-center mb-3">
            <img src="https://cdn.acsdev.in/Rentastic/reset.png" alt="Reset" className="w-40 h-40 object-contain" />
          </div>
          <p className="text-md font-bold text-gray-900 mt-2">Reset Password</p>
          <p className="text-sm text-gray-500 mt-1 text-center px-4">
            Please create a new password for your account.
          </p>
        </div>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          {/* New Password */}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500 transition-all">
            <MdLock className="text-gray-500 text-lg mr-2" />
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full py-2 outline-none text-gray-700 bg-transparent placeholder-gray-400"
              required
            />
          </div>

          {/* Confirm Password */}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500 transition-all">
            <MdLock className="text-gray-500 text-lg mr-2" />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full py-2 outline-none text-gray-700 bg-transparent placeholder-gray-400"
              required
            />
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || !!error}
            className={`w-full bg-green-500 text-white font-semibold py-2 rounded-full shadow transition-colors duration-300 ${
              loading || error ? "opacity-70 cursor-not-allowed" : "hover:bg-green-600"
            }`}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>

        <div className="text-center mt-6 text-sm text-gray-600">
          Remembered your password?{" "}
          <button
            onClick={() => navigate("/login")}
            className="text-orange-500 font-semibold hover:underline"
          >
            Back to Login
          </button>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
